import { Marketplace } from 'src/WebApiController';

import { getIsInternationalEvent } from './eventWithDataUtils';

export const shouldShowExternalMarketplaceBroadcastForEvent = (
  externalMarketplace: Marketplace,
  eventCountryCode: string | null | undefined
): boolean => {
  if (externalMarketplace === Marketplace.StubHub) {
    // Not an external marketplace
    return false;
  }

  const isInternationalEvent = getIsInternationalEvent(eventCountryCode);
  if (externalMarketplace === Marketplace.Gigsberg) {
    // Gigsberg is only shown for international events
    // If we don't have event country code, we're in a bulk edit scenario so show Gigsberg
    return !eventCountryCode || isInternationalEvent;
  }

  // Other external marketplaces are only shown for US events
  return !isInternationalEvent;
};
